import { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ClientsPanel from '../components/laws/ClientsPanel';
import LegalAreasPanel from '../components/laws/LegalAreasPanel';
import ClustersPanel from '../components/laws/ClustersPanel';
import LawManagementPanel from '../components/laws/LawManagementPanel';
import TopicsPanel from '../components/laws/TopicsPanel';
import ChangeRadarPanel from '../components/laws/ChangeRadarPanel';
 
const AdminLaws = () => {
  const [key, setKey] = useState('main');

  return (
    <div className="container mt-4">
      <h2>Datenmanagement</h2>
      <Tabs activeKey={key} onSelect={(k) => setKey(k || 'main')} className="mb-3">
        <Tab eventKey="main" title="Gesamt"><LawManagementPanel /></Tab>
        <Tab eventKey="clients" title="Kunden"><ClientsPanel /></Tab>
        <Tab eventKey="legal_areas" title="Rechtsgebiete"><LegalAreasPanel /></Tab>
        <Tab eventKey="clusters" title="Cluster"><ClustersPanel /></Tab>
        <Tab eventKey="topics" title="Themen"><TopicsPanel /></Tab>
        <Tab eventKey="change_radar" title="Änderungsradar"><ChangeRadarPanel /></Tab>
      </Tabs>
    </div>
  );
};

export default AdminLaws;
